<template>
    <el-button type="success" size="mini" v-if="isShow" icon="el-icon-edit" :disabled="disabled">编辑</el-button>
</template>

<script>
export default {
    name: "EditButton",
    props: {
        rule: '',
        click: '',
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isShow() {
            if(this.rule) {
                return this.$rule.checkRule(this.rule);
            }else{
                return true;
            }
        }
    }
}
</script>
